import moment from "moment";
import { Cell } from "react-table";
import { DeviceModel } from "src/api/iot/iot-types";
import { BaseTooltip } from "src/components";
import Link from "src/components/PartnerLink";
import { PagePath } from "src/pages/product/details";
import { YmdFormat } from "src/utils";

// iot 탭 관리 페이지 > 탭 관리 테이블 columns
export const iotTabColumns = [
  {
    Header: "순서",
    width: 80,
  },
  {
    Header: "id",
    width: 120,
  },
  {
    Header: "탭 종류",
    width: 80,
  },
  {
    Header: "탭 명",
    width: 320,
  },
  {
    Header: "IoT",
    width: 80,
  },
  {
    Header: "기기 연결",
    width: 80,
  },
  {
    Header: "편집",
    width: 80,
  },
  {
    Header: "삭제",
    width: 60,
  },
];

export const createIotConfigColumns = (pathname: string): any[] => [
  {
    Header: "IoT ID",
    accessor: "id",
    width: 120,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return (
        <Link
          className="text-underline"
          to={PagePath.iotConfig.detail.replace(":id", value)}
          target={pathname.includes("iot-config/setting") ? "_blank" : "_self"}
        >
          {value}
        </Link>
      );
    },
  },
  {
    Header: "IoT 구분",
    accessor: "platformDevice.platformAccount.platform",
    width: 140,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <span className="w-100 text-left">{value === "ST" ? "SmartThings" : value === "B_IOT" ? "b.IoT" : "ST Ent."}</span>;
    },
  },
  {
    Header: "기기명",
    accessor: "internalDisplayName",
    width: 240,
    Cell: ({ row }: Cell<DeviceModel>) => {
      const id = row.original.id;
      const internalDisplayName = row.original.internalDisplayName;
      return (
        <Link
          className="text-underline text-left w-100 ellipsis"
          to={PagePath.iotConfig.detail.replace(":id", String(id))}
          target={pathname.includes("iot-config/setting") ? "_blank" : "_self"}
        >
          {internalDisplayName}
        </Link>
      );
    },
  },
  {
    Header: "기기명(노출)",
    accessor: "primaryDisplayName",
    width: 240,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <BaseTooltip className="text-left w-full" contents={value} />;
    },
  },
  {
    Header: "DisplayName", // labels 에서 찾기
    accessor: "displayName",
    width: 180,
    Cell: ({ row }: Cell<DeviceModel>) => {
      const labels = row.original.labels;
      const findDisplayName = labels?.find((label) => label.name === "DisplayName");

      return <BaseTooltip className="text-left w-full" contents={findDisplayName?.value || "-"} />;
    },
  },
  {
    Header: "Device ID",
    accessor: "platformDevice.id",
    width: 310,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <span className="w-100 text-left">{value || "-"}</span>;
    },
  },
  {
    Header: "Name",
    accessor: "platformDevice.name",
    width: 310,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <span className="w-100 text-left">{value}</span>;
    },
  },
  {
    Header: "Type",
    accessor: "platformDevice.type",
    width: 180,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <span className="w-100 text-left">{value || "-"}</span>;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "lastModifiedDate",
    width: 160,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <p className="text-center">{value ? moment(value).format(YmdFormat.FULL) : "-"}</p>;
    },
  },
];

// 기존 방식과의 호환성을 위한 기본 export (필요시)
const IotConfigColumns = createIotConfigColumns("");
export default IotConfigColumns;
